<template>
	<label class="checkbox">
		<input
			class="checkbox__input"
			type="checkbox"
			v-model="check_calc"
		>

		<svg class="checkbox__check" width="24" height="24" viewBox="0 0 24 24">
			<polyline points="20 6 9 17 4 12"></polyline>
		</svg>

		<span class="checkbox__text">
			<slot>
				{{props.item.name}}
			</slot>
		</span>
	</label>
</template>

<script setup>
import {ref, computed} from 'vue'

const props = defineProps({
  item: Object, 
})
const emits = defineEmits([ 'input' ])

const check_calc = computed({
  get() {
    return props.item.selected ? true : false
  },
  set(val) {
    emits('input', props.item.id, val)
  }
})
  
</script>

